<template>
	<v-bottom-navigation
		app
		fixed
		color="secondary"
	>
		<v-btn
			v-for="route in filteredItems"
			:key="route.name"
			:value="route.name"
			:to="route"
		>
			<template v-if="route.meta">
				<span v-if="route.meta.title">
					{{ route.meta.title }}
				</span>
				<span v-else>
					{{ route.name }}
				</span>
				<v-icon v-if="route.meta.icon">
					{{ route.meta.icon }}
				</v-icon>
			</template>
		</v-btn>
	</v-bottom-navigation>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'BottomBar',
	computed: {
		...mapState([
			'user',
		]),
		filteredItems () {
			if (this.user && this.user._secondary_support_member === true) {
				return this.items.filter(route => !(route.meta && route.meta.visibleForFullMembersOnly))
			}
			return this.items
		},
	},
	props: {
		items: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
}
</script>
